import { useEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export const useGSAPAnimations = () => {
    useEffect(() => {
        const ctx = gsap.context(() => {

            gsap.utils.toArray('.section-title h2').forEach(el => {
                gsap.fromTo(el,
                    { opacity: 0, x: -50 },
                    {
                        opacity: 1, x: 0, duration: 0.75, ease: 'power3.out',
                        scrollTrigger: { trigger: el, start: 'top 87%', toggleActions: 'play none none reverse' }
                    }
                );
            });

            gsap.utils.toArray('.gsap-card').forEach((card, i) => {
                gsap.fromTo(card,
                    { opacity: 0, y: 55, scale: 0.96 },
                    {
                        opacity: 1, y: 0, scale: 1, duration: 0.65, delay: (i % 3) * 0.12,
                        ease: 'back.out(1.3)',
                        scrollTrigger: { trigger: card, start: 'top 90%', toggleActions: 'play none none reverse' }
                    }
                );
            });

            const heroImg = document.querySelector('.hero-image-parallax');
            if (heroImg) {
                gsap.to(heroImg, {
                    y: -70, ease: 'none',
                    scrollTrigger: { trigger: '.hero-section', start: 'top top', end: 'bottom top', scrub: 1.2 }
                });
            }

            gsap.utils.toArray('.timeline-item').forEach((item, i) => {
                gsap.fromTo(item,
                    { opacity: 0, x: i % 2 === 0 ? -40 : 40 },
                    {
                        opacity: 1, x: 0, duration: 0.7, ease: 'power2.out',
                        scrollTrigger: { trigger: item, start: 'top 88%', toggleActions: 'play none none reverse' }
                    }
                );
            });

        });

        return () => { ctx.revert(); ScrollTrigger.getAll().forEach(t => t.kill()); };
    }, []);
};
